export default __webpack_public_path__ + "static/media/healthq1.a3b56a16.svg";